import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import AuthGuard from "./contexts/AuthGuard";
import AdminGuard from "./contexts/AdminGuard";
import Layout from "./components/Layout";
// import ThermoWaterLoading from "./components/ThermoWaterLoading";
import LoadingPage from "./pages/LoadingPage";
import VoucherPage from "./pages/VoucherPage";

// Lazy load pages
const HomePage = lazy(() => import("./pages/HomePage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const AgreePage = lazy(() => import("./pages/AgreePage"));
const IdentityPage = lazy(() => import("./pages/IdentityPage"));
const QuestionnairePage = lazy(() => import("./pages/QuestionnairePage"));
const AppointmentPage = lazy(() => import("./pages/AppointmentPage"));
const PaymentPage = lazy(() => import("./pages/PaymentPage"));
const ThankYouPage = lazy(() => import("./pages/ThankYouPage"));
const ReportPage = lazy(() => import("./pages/ReportPage"));
const ForgetPasswordPage = lazy(() => import("./pages/ForgetPasswordPage"));
const ForgetPasswordResetPage = lazy(() => import("./pages/ForgetPasswordResetPage"));
const ProfileSettingPage = lazy(() => import("./pages/ProfileSettingPage"));
const PromotionPage = lazy(() => import("./pages/PromotionPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const AppointmentHistoryPage = lazy(() => import("./pages/AppointmentHistoryPage"));
const AdminCheckinPage = lazy(() => import("./pages/admin/AdminCheckinPage"));
const AdminDashboardPage = lazy(() => import("./pages/admin/AdminDashboardPage"));
const AppointmentMammogramPage = lazy(() => import("./pages/AppointmentMammogramPage"));
const PackageSelectionPage = lazy(() => import("./pages/PackageSelectionPage"));
const LineMamogramCheckPage = lazy(() => import("./pages/LineMamogramCheckPage"));
const LineMamogramResultPage = lazy(() => import("./pages/LineMamogramResultPage"));
const BookingMammogramPage = lazy(() => import("./pages/BookingMammogramPage"));
const SurveyPage = lazy(() => import("./pages/SurveyPage"));
const SignAgreePage = lazy(() => import("./pages/SignAgreePage"));

export default function AppRouter() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Routes>
        <Route path="/survey" element={<SurveyPage />} />
        <Route element={<Layout background="gradient" />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
          <Route path="/appointment" element={<AuthGuard><AppointmentPage /></AuthGuard>} />
          <Route path="/packages" element={<AuthGuard><PackageSelectionPage /></AuthGuard>} />
          <Route path="/forget-password" element={<ForgetPasswordPage />} />
          <Route path="/forget-password/:token" element={<ForgetPasswordResetPage />} />
        </Route>
        <Route element={<Layout background="white" />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/agree" element={<AgreePage />} />
          <Route path="/sign-agree" element={<SignAgreePage />} />
          <Route path="/identity" element={<IdentityPage />} />
          <Route path="/payment" element={<AuthGuard><PaymentPage /></AuthGuard>} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="/report" element={<AuthGuard><ReportPage /></AuthGuard>} />
          <Route path="/history" element={<AuthGuard><HistoryPage isHistory={true} /></AuthGuard>} />
          <Route path="/booking" element={<AuthGuard><HistoryPage isHistory={false} /></AuthGuard>} />
          <Route path="/appointment-history" element={<AuthGuard><AppointmentHistoryPage /></AuthGuard>} />
          <Route path="/profile-settings" element={<AuthGuard><ProfileSettingPage /></AuthGuard>} />
          <Route path="/promotions" element={<AuthGuard><PromotionPage /></AuthGuard>} />
          <Route path="/vouchers" element={<AuthGuard><VoucherPage /></AuthGuard>} />
          <Route path="/admin/checkin" element={<AdminGuard><AdminCheckinPage /></AdminGuard>} />
          <Route path="/admin/dashboard" element={<AdminGuard><AdminDashboardPage /></AdminGuard>} />
          {/* ชั่วคราวเพื่อทดสอบ - ไม่ต้องผ่าน guard */}
          <Route path="/test/checkin" element={<AdminCheckinPage />} />
          <Route path="/mammogram/result" element={<LineMamogramResultPage />} />
          <Route path="/booking-mammogram" element={<BookingMammogramPage />} />
        </Route>
        <Route element={<Layout background="mammogram" />}>
          <Route path="/appointment-mammogram" element={<AuthGuard><AppointmentMammogramPage /></AuthGuard>} />
          <Route path="/mammogram" element={<LineMamogramCheckPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
